import { render, staticRenderFns } from "./InstantSwitchEl.vue?vue&type=template&id=b0694534&scoped=true&"
import script from "./InstantSwitchEl.vue?vue&type=script&lang=ts&"
export * from "./InstantSwitchEl.vue?vue&type=script&lang=ts&"
import style0 from "./InstantSwitchEl.vue?vue&type=style&index=0&id=b0694534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0694534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
